import eventStore from './events';
import forumStore from './forum';
import messageStore from './messages';
import notificationStore from './notifications';
import userStore from './user';

export default {
  eventStore,
  forumStore,
  messageStore,
  notificationStore,
  userStore,
};
